export const AI_FAILURE_TYPES = [
  { value: "service_unreachable",       label: "Service Unreachable"       },
  { value: "qure_services_unreachable", label: "Qure Services Unreachable" },
  { value: "high_unprocessed_images",   label: "High Unprocessed Images"   },
  { value: "pipeline_failure",          label: "Pipeline Failure"          },
];

export const GATEWAY_FAILURE_TYPES = [
  { value: "gateway_offline",   label: "Gateway Offline"  },
  { value: "cpu_usage_high",    label: "CPU Usage High"   },
  { value: "memory_usage_high", label: "Memory Usage High"},
  { value: "disk_space_low",    label: "Disk Space Low"   },
  { value: "temperature_high",  label: "CPU Temp High"    },
  { value: "nvidia_gpu_inactive", label: "NVIDIA GPU Inactive" },
  { value: "forwarding_failure", label: "Task Failures"   },
];
